//t = current time
//b = start value
//c = change in value
//d = duration
function easeInOutQuad(t, b, c, d) {
  t /= d / 2
  if (t < 1) return c / 2 * t * t + b
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

// https://gist.github.com/felipenmoura/650e7e1292c1e7638bcf6c9f9aeb9dd5
export const scrollTo = (to, duration = 500) => {
  //t = current time
  //b = start value
  //c = change in value
  //d = duration
  const easeInOutQuad = function (t, b, c, d) {
    t /= d/2;
    if (t < 1) return c/2*t*t + b;
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
  };

  return new Promise((resolve, reject) => {
    const element = document.scrollingElement;

    if (typeof to === 'string') {
      to = document.querySelector(to) || reject();
    }
    if (typeof to !== 'number') {
      to = to.getBoundingClientRect().top + element.scrollTop;
    }

    let start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;

    const animateScroll = function() {
        currentTime += increment;
        let val = easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if(currentTime < duration) {
            setTimeout(animateScroll, increment);
        } else {
          resolve();
        }
    };
    animateScroll();
  });
}
/*

Traverse up finding the nearest scrollable parent element.

Copied from:
https://htmldom.dev/get-the-first-scrollable-parent-of-an-element/

*/

function isScrollable(el) {
  const scrollableParentDataset = el.dataset.scrollableParent
  const hasScrollableContent = el.scrollHeight > el.clientHeight
  const overflowYStyle = typeof window.getComputedStyle === 'function' ?
    window.getComputedStyle(el).overflowY : ''
  const isOverflowHidden = overflowYStyle.includes('hidden')
  return scrollableParentDataset || (hasScrollableContent && !isOverflowHidden)
}

export function getScrollableParent(el) {
  const defaultElement = document.scrollingElement || document.documentElement
  if (!el || el.isSameNode(defaultElement)) {
    return defaultElement
  }
  if (isScrollable(el)) {
    return el
  }
  return getScrollableParent(el.parentNode)
}
